<template>
  <div class="only-flex items-center">
    <template
      v-if="
        isValuerOrTypeDispatcher &&
        [enums.requestStatus.SUBMITTED, enums.requestStatus.VALUED].includes(props.row.status) &&
        ['dvm', 'ovm'].includes(props.row.valuation_type)
      "
    >
      <router-link
        :to="{
          name: 'valuation.request',
          params: { action: 'extra-info' },
          query: { valuation_request_ref: props.row.valuation_request_ref },
        }"
      >
        {{ props.row.valuation_request_ref }}
      </router-link>
    </template>
    <span v-else>
      {{ props.row.valuation_request_ref }}
    </span>
    <re-button
      v-if="isValuerOrTypeDispatcher && props.row.other_data?.similar_requests?.length"
      size="xs"
      color="warning"
      dense
      class="q-ma-sm"
      icon="ic-duplicates"
      @click="emit('show-duplicates', props.row)"
    />
  </div>
</template>
<script setup>
import { computed } from 'vue'

import { useCurUser } from '@/composables/useCurUser'
import enums from '@/plugins/enums'

// don't automatically insert attrs in root div:
defineOptions({ inheritAttrs: false })

const props = defineProps({
  value: {
    type: String,
    default: '',
  },
  row: {
    type: Object,
    default: () => ({}),
  },
})

const emit = defineEmits(['show-duplicates'])

const { hasRole } = useCurUser()

const isValuerOrTypeDispatcher = computed(
  () => hasRole('dispatcher', props.row.valuation_type) || props.row.valuer?.is_self
)
</script>

<style scoped>
.only-flex {
  display: flex;
}
</style>
